<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon d-flex align-items-center">
            <div class="card-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title mb-0 me-3 flex-grow-1">
              Profile:
              <small
                class="category"
                *ngIf="!this.form.get('business_name')?.value"
                >Personal</small
              >
              <small
                class="category"
                *ngIf="this.form.get('business_name')?.value"
                >Business</small
              >
            </h4>
            <div class="ms-auto">
              <i
                class="fas fa-edit text-dark icon__edit"
                (click)="enableUpdate()"
              ></i>
            </div>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="firstname"
                      >Name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="firstname"
                      formControlName="firstname"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('firstname')"
                    >
                      El nombre es requerido
                    </div>
                  </div>
                </div>
                <div class="col-6 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="lastname"
                      >Lastname</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="lastname"
                      formControlName="lastname"
                      [readOnly]="!update"
                    />
                    <div
                      class="invalid-feedback"
                      *ngIf="isFieldInvalid('lastname')"
                    >
                      El apellido es requerido
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="username"
                      >Email</label
                    >
                    <div class="d-flex">
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                        [readOnly]="!update"
                      />
                      <button
                        class="btn btn-sm btn-outline-dark"
                        type="button"
                        (click)="openEmail(form.get('username')?.value)"
                        title="Send email"
                      >
                        <i class="fas fa-envelope"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-6"
                  *ngIf="this.form.get('business_name')?.value"
                >
                  <div class="form-group">
                    <label class="bmd-label-floating" for="bussines_name"
                      >Bussines name</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="bussines_name"
                      formControlName="bussines_name"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-5 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="indicative"
                      >Indicative</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      id="indicative"
                      formControlName="indicative"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
                <div class="col-7 col-md-6">
                  <div class="form-group">
                    <label class="bmd-label-floating" for="phone">Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      id="phone"
                      formControlName="phone"
                      [readOnly]="!update"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <!--  <div class="col-md-6">
                      <div class="form-group">
                        <label class="bmd-label-floating" for="password">Contraseña</label>
                        <input type="password" class="form-control" id="password" formControlName="password">
                      </div>
                    </div> -->
                <div class="col-md-12 d-flex justify-content-center">
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        id="status"
                        formControlName="status"
                      />
                      <label class="custom-control-label" for="status"
                        >Active</label
                      >
                    </div>
                  </div>
                  <div
                    class="form-group d-flex justify-content-center align-items-center gap-4"
                  >
                    <div class="custom-control custom-switch mt-4 checkbox">
                      <input
                        type="checkbox"
                        class="custom-control-input suspended"
                        id="suspended"
                        formControlName="suspended"
                      />
                      <label
                        class="custom-control-label suspended"
                        for="suspended"
                        >Suspended</label
                      >
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div class="row mb-6 justify-content-center text-center">
                <!-- <div class="col-md-12 col__button-bank"> -->
                  <div class="col-md-12">
                  <!-- class="btn btn-dark btn-sm btn-step" -->
                  <a
                    [ngClass]="{
                      btn: true,
                      'btn-sm': true,
                      'btn-dark': true,
                      'btn-step': step !== 1,
                      'btn-step__selected': step === 1,
                    }"
                    (click)="changeStep(1)"
                  >
                    Bank
                  </a>
                  <a
                    [ngClass]="{
                      btn: true,
                      'btn-sm': true,
                      'btn-dark': true,
                      'btn-step': step !== 2,
                      'btn-step__selected': step === 2,
                    }"
                    (click)="changeStep(2)"
                  >
                    History
                  </a>
                  <button
                    type="submit"
                    class="btn btn-dark btn-sm btn-step"
                    [disabled]="form.invalid"
                  >
                    {{ id ? "Update" : "" }}
                  </button>
                  <button class="btn btn-dark btn-step" (click)="back()">
                    Back
                  </button>
                </div>
              </div>
              <br />

              <div class="row text-center"></div>

              <!-- bank -->
              <div class="row" formGroupName="dataAdditional" *ngIf="step == 1">
                <div class="col-12">
                  <h4 class="title">Cards ({{ cards.length || 0 }})</h4>
                </div>
                <!-- <div class="row" formGroupName="vehicles"> -->
                <div
                  class="row row_data"
                  formArrayName="cards"
                  *ngFor="let card of cards.controls; let i = index"
                >
                  <div class="col-md-12 text-center" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="cardnumber"
                        ># {{ i + 1 }}</label
                      >
                    </div>
                  </div>
                  <div class="col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="cardnumber"
                        >Card number</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="cardnumber"
                        formControlName="cardnumber"
                      />
                    </div>
                  </div>
                  <div class="col-md-6" formGroupName="{{ i }}">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="expiration"
                        >Expiration</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="expiration"
                        formControlName="expiration"
                      />
                    </div>
                  </div>

                  <!-- Línea divisora entre vehículos -->
                  <div class="col-12">
                    <hr class="bg-dark border-0 my-4" />
                  </div>
                </div>
              </div>

              <!-- History -->
              <div class="row" *ngIf="step == 2">
                <div class="col-12">
                  <h4 class="title">History</h4>
                </div>
                <div class="col-12">
                  <div class="row mb-3">
                    <div class="col-md-8">
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          placeholder="Search reference"
                          (input)="searchService($event)"
                          autocomplete="off"
                        />
                        <span class="input-group-text bg-transparent"
                          ><i class="fas fa-search text-dark"></i
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="grid"
                  *ngFor="let service of searchedService; index as i"
                >
                  <div
                    *ngIf="service['data'][0].when['nameService'] != 'RUNNER'"
                  >
                    <div class="row">
                      <div class="col-4">
                        <label class="labelHeader">{{
                          service["data"][0].when["nameService"]
                        }}</label>
                      </div>
                      <div class="col-4 centerText">
                        <label class="labelHeader2">{{ service["ref"] }}</label>
                      </div>
                      <div class="col-4 textRight">
                        <label class="labelHeader1">{{
                          formatDate(service["createdAt"])
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-2">
                        <label class="labelFrom">From:</label>
                      </div>
                      <div class="col">
                        <label class="address">{{
                          service["data"][0].fullAddress
                        }}</label>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col-2">
                        <label class="labelTo">To:</label>
                      </div>
                      <div class="col">
                        <label class="address">{{
                          service["data"][0]["listDrop"][0].fullAddress
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row rows">
                      <div class="col-6">
                        <label class="label__total pl-1"
                          >Total: {{ service["commission"] }}
                        </label>
                      </div>
                      <div class="col-6 text-right">
                        <label
                          class="label__total pr-1"
                          (click)="getDataService(service['_id'])"
                          >Full receipt</label
                        >
                      </div>
                      <!-- <div class="col-2 textRight">
                        <ion-icon
                          class="iconShare"
                          name="share-social-outline"
                        ></ion-icon>
                      </div> -->
                    </div>
                  </div>

                  <div
                    *ngIf="
                      service['data'][0]['when']['nameService'] == 'RUNNER'
                    "
                  >
                    <div class="row">
                      <div class="col-4">
                        <label class="labelHeader">RUNNER</label>
                      </div>
                      <div class="col-4 centerText">
                        <label class="labelHeader2">{{ service["ref"] }}</label>
                      </div>
                      <div class="col-4 textRight">
                        <label class="labelHeader1">{{
                          formatDate(service["createdAt"])
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row">
                      <div class="col-2">
                        <label class="labelFrom"
                          >{{
                            getNumber(service["originalIndex"])
                          }}
                          Stop:</label
                        >
                      </div>
                      <div class="col">
                        <label class="address">{{
                          service["data"][0].fullAddress
                        }}</label>
                      </div>
                    </div>
                    <br />
                    <div class="row rows">
                      <div class="col-6">
                        <label class="label__total pl-1"
                          >Total: {{ service["commission"] }}
                        </label>
                      </div>
                      <div class="col-6 text-right">
                        <label
                          class="label__total pr-1"
                          (click)="getDataService(service['_id'])"
                          >Full receipt</label
                        >
                      </div>
                      <!-- <div class="col-2 textRight">
                        <ion-icon
                          class="iconShare"
                          name="share-social-outline"
                        ></ion-icon>
                      </div> -->
                    </div>
                  </div>
                  <!-- modal -->
                </div>
              </div>

              <div class="clearfix"></div>
            </form>
            <!-- Modal service detail-->
            <div
              class="modal fade"
              tabindex="-1"
              [ngClass]="{ 'show d-block': showModal }"
            >
              <!-- style="background-color: rgba(0,0,0,0.5);" -->
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <button
                      type="button"
                      class="close btn btn-link btn-sm btn-close"
                      (click)="closeModal()"
                    >
                      &times;
                    </button>
                  </div>
                  <div class="modal-body">
                    <div>
                      <div class="row">
                        <div class="col-6">
                          <label class="labelHeaderModal"
                            ><strong>{{ data.nameService }}</strong></label
                          >
                        </div>
                        <div class="col-6 text-right">
                          <label class="labelHeader1">{{
                            formatDate(data.createdAt)
                          }}</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-6">
                          <label
                            >Stops : {{ data.listDropAddress.length }}
                          </label>
                        </div>
                        <div class="col-6 text-right">
                          <label>Ref #: {{ data.ref }}</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <p class="paragraph">
                            From:
                            <label class="address">{{ data.address }}</label>
                          </p>
                          <p
                            *ngIf="data.listDropAddress.length == 1"
                            class="paragraph3"
                          >
                            To:
                            <label class="address2">{{
                              data.listDropAddress
                            }}</label>
                          </p>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.listDropAddress.length > 1">
                        <div class="col">
                          <p
                            class="paragraph1"
                            *ngFor="let address of data.listDropAddress"
                          >
                            To:
                            <label class="address2">{{ address }}</label>
                          </p>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col-6">
                          <label
                            >1 Pick Up / {{ data.listDropAddress.length }} Drop
                            Off</label
                          >
                        </div>
                        <div class="col-6 text-right">
                          <label>Ref #: {{ data.ref }}</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col-6">
                          <label>Pick up time: {{ data.pickUptime }} </label>
                        </div>
                        <div class="col-6 text-right">
                          <label>Drop off: {{ data.dropOffTime }}</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <label>Booking Fee: USD $5.00</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <label> 3-mile fixed fee :USD $30.00</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col">
                          <label> Miles extra (1 mile = USD $1.20): 9 mi</label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col">
                          <label> Total miles : {{ data.distance }}</label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService !== 'RUNNER'">
                        <div class="col">
                          <label> Tip : </label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-6">
                          <label class="time">
                            Arrival time: {{ data.timeStop }}
                          </label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-12">
                          <label class="time">
                            Things To-Do time spent : 1 hour, USD $50.00
                          </label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-7">
                          <label> Total: USD $ {{ data.price }} </label>
                        </div>

                        <div class="col-5">
                          <i class="fa-solid fa-credit-card iconCard"></i>
                          <label class="labelCard"> visa: </label>
                        </div>
                      </div>

                      <div class="row" *ngIf="data.nameService === 'RUNNER'">
                        <div class="col-12">
                          <label> Things To-Do Runner : Juan Garcia </label>
                        </div>
                      </div>

                      <div class="row">
                        <div
                          class="col-7"
                          *ngIf="data.nameService !== 'RUNNER'"
                        >
                          <label> Driver: Juan Garcia </label>
                        </div>
                        <div class="col-5">
                          <label class="ratingPlate"> Rating: </label>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-7">
                          <label> White Hyundai 2020 Santa Fe</label>
                        </div>
                        <div class="col-5">
                          <label class="ratingPlate"> Plate : 96P463 FL </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-md-4">
        <div class="card card-profile">
          <div class="card-avatar">
            <img class="img" [src]="driverImgUrl" style="cursor: pointer" />
          </div>
          <div class="card-body">
            <h6 class="card-category text-gray">Perfil de usuario</h6>
            <h4 class="card-title">
              {{ form.get("firstname")?.value }}
              {{ form.get("lastname")?.value }}
            </h4>
            <p class="card-description">
              Aquí puedes editar los datos del usuario. Los cambios se
              reflejarán en el sistema.
            </p>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</div>
